import { Button, Form, Offcanvas } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface Props {
    show: boolean;
    onHide: () => void;
}

const EnterpriseRequest = ({ show, onHide }: Props) => {
    const { t } = useTranslation('Tariff');

    return (
        <Offcanvas show={show} onHide={onHide} placement="end">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>{t('enterpriseRequestTitle')}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <Form>
                    <Form.Group className="mb-3" controlId="enterprise-first-name">
                        <Form.Label>{t('firstName')}</Form.Label>
                        <Form.Control type="text" placeholder={t('firstName')} />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="enterprise-last-name">
                        <Form.Label>{t('lastName')}</Form.Label>
                        <Form.Control type="text" placeholder={t('lastName')} />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="enterprise-phone">
                        <Form.Label>{t('phoneNumber')}</Form.Label>
                        <Form.Control type="tel" placeholder={t('phoneNumber')} />
                    </Form.Group>
                    <Form.Group className="mb-4" controlId="enterprise-email">
                        <Form.Label>{t('emailAddress')}</Form.Label>
                        <Form.Control type="email" placeholder={t('emailAddress')} />
                    </Form.Group>
                    <Button type="button" className="w-100">
                        {t('sendRequest')}
                    </Button>
                </Form>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default EnterpriseRequest;
